import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import {
  IA_STI_INQUIRY_RESET_SHIP_TO_DETAILS,
} from './constants';

export function resetShipToDetails() {
  return {
    type: IA_STI_INQUIRY_RESET_SHIP_TO_DETAILS,
  };
}

export function useResetShipToDetails() {
  const dispatch = useDispatch();
  const boundAction = useCallback(() => dispatch(resetShipToDetails()), [dispatch]);
  return { resetShipToDetails: boundAction };
}

export function reducer(state, action) {
  switch (action.type) {
    case IA_STI_INQUIRY_RESET_SHIP_TO_DETAILS:
      return {
        ...state,
        shipToDetails: null,
        fetchShipToDetailsError: null,
      };

    default:
      return state;
  }
}


